import { Box, Button, Link } from '@mui/material';
import { useNavigate } from 'react-router';

import GoLogo from '@/components/GoLogo';
import Typography from '@/components/Typography';
import { SUPPORT_EMAIL } from '@/constants/constants';
import { spacing } from '@/constants/ui';
import { useAppDispatch } from '@/hooks/redux-hooks';
import DefaultLayout from '@/layouts/DefaultLayout';
import { useGxTokenFromStorage, useTripTokenFromStorage } from '@/services/storage';
import { logout } from '@/slices/authSlice';

const NotFound = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gxToken = useGxTokenFromStorage();
  const tripToken = useTripTokenFromStorage();
  const loggedIn = !!gxToken || !!tripToken;
  return (
    <DefaultLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          mt: { xs: 0, md: '8%' },
          justifyContent: {
            xs: 'center',
            md: 'flex-start'
          },
          gap: spacing['4']
        }}
      >
        <GoLogo size={40} />
        <Typography
          size={36}
          sx={{ fontWeight: 700, textAlign: 'center' }}
        >
          Oops! Something went wrong.
        </Typography>
        <Typography size={24}>Let's jump back in</Typography>
        <Button
          fullWidth
          sx={{
            fontSize: 18,
            maxWidth: 300
          }}
          variant='contained'
          onClick={() => {
            if (!loggedIn) dispatch(logout());
            navigate(loggedIn ? '/markets' : '/login');
          }}
        >
          Go to {loggedIn ? 'Markets' : 'Login'}
        </Button>
        <Typography sx={{ textAlign: 'center' }}>
          Any issues? Drop us a line at{' '}
          <Link
            color='text.primary'
            href={`mailto:${SUPPORT_EMAIL}`}
            sx={{ whiteSpace: 'nowrap' }}
            target='_top'
          >
            {SUPPORT_EMAIL}
          </Link>
        </Typography>
      </Box>
    </DefaultLayout>
  );
};

export default NotFound;
